import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "a-auth full-height" }
const _hoisted_2 = { class: "ion-padding a-auth__content-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "load-wrap ion-text-center"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "a-auth__note d-flex ion-align-items-center ion-no-margin" }
const _hoisted_6 = { class: "version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "ion-no-padding ion-padding-bottom",
        fullscreen: true,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Welcome", -1)),
              _createVNode(_component_ion_text, {
                color: "medium",
                class: "ion-margin-bottom"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Sign in to continue", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding ion-padding-top",
                style: _normalizeStyle($options.valid($data.v.email))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("E-mail", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
                    class: "ion-padding-vertical",
                    name: "email",
                    type: "email",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.onEmailChange($event.target.value))),
                    onIonBlur: _cache[2] || (_cache[2] = ($event: any) => ($options.onBlur($data.v.email)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding",
                style: _normalizeStyle($options.valid($data.v.password))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Password", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: $data.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.password) = $event)),
                    class: "ion-padding-vertical pwd",
                    name: "password",
                    type: "password",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.onPasswordChange($event.target.value))),
                    onIonBlur: _cache[5] || (_cache[5] = ($event: any) => ($options.onBlur($data.v.password)))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_router_link, {
                    tag: "ion-button",
                    class: "ion-no-margin forgot",
                    to: "/app/forgot",
                    fill: "clear",
                    slot: "end"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Forgot password", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["style"]),
              ($data.isDesktop)
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 0,
                    class: "ion-no-padding",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_checkbox, {
                        checked: $data.rememberMe,
                        class: "ion-margin-start",
                        slot: "start",
                        onIonChange: _cache[6] || (_cache[6] = ($event: any) => ($options.remember($event)))
                      }, null, 8, ["checked"]),
                      _createVNode(_component_ion_label, { class: "ion-padding-vertical" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("Remember me", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", { class: "lds-roller" }, [
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div"),
                      _createElementVNode("div")
                    ], -1),
                    _createElementVNode("p", null, "Loading...", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ion_button, {
                      disabled: $options.isFormInvalid,
                      class: "--default a-auth__button ion-margin-vertical",
                      onClick: $options.login
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Sign in", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "center" }, "Don't have an account?", -1)),
                      _createVNode(_component_router_link, {
                        tag: "ion-text",
                        class: "ion-no-padding ion-margin-start",
                        color: "primary",
                        fill: "clear",
                        to: "/app/register"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Sign up", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])),
              _createElementVNode("div", _hoisted_6, "version: " + _toDisplayString($data.version), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}